export default "__VITE_ASSET__coScVBfQ__"